module.exports = __webpack_public_path__ + "img/cured_meat.1d5641eb.png";